import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme } from "shared/lib/styles";

import { FlexContainer as ContentActionBar } from "scmp-app/components/content/content-action-bar/styles";
import { Flag } from "scmp-app/components/content/content-headline/content-headline-tag/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "scmp-app/components/content/content-headline/styles";
import { StyledTopicLink } from "scmp-app/components/content/content-topic-link/styles";
import { EntityLink } from "scmp-app/components/entity-link";
import { MyDailyFiveNumber } from "scmp-app/components/my-news/my-daily-five/my-daily-five-number";
export const Container = styled.div`
  display: flex;
  flex-direction: row;

  inline-size: 100%;
  margin-block-end: 20px;
  padding-block-end: 20px;
  border-block-end: 1px solid #e9e9e9;
  &:last-child {
    margin-block-end: 24px;
    padding-block-end: 0;
    border-block-end: 0;
  }

  ${theme.breakpoints.up("tablet")} {
    inline-size: auto;

    &:nth-child(2),
    &:nth-child(4) {
      margin-block-end: 0;
      padding-block-end: 0;
      border-block-end: 0;
    }
  }

  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 20px;
    padding-block-end: 20px;
  }
`;

export const Wrapper = styled.div`
  flex: 1;
  ${theme.breakpoints.up("tablet")} {
    flex: auto;
  }
`;

export const CoverEntityLink = styled(EntityLink)`
  display: block;

  ${theme.breakpoints.only("tablet")} {
    display: none;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  margin-block-end: 12px;
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 16px;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    flex-direction: column;
  }

  ${CoverEntityLink} {
    flex: 0 80px;
    ${theme.breakpoints.up("tablet")} {
      flex: 1;

      inline-size: 50%;
    }
    ${theme.breakpoints.up("mediumDesktop")} {
      inline-size: 100%;
    }
  }
`;

export const TextWrapper = styled.div`
  flex: 1;

  margin-block-end: 13.5px;
  margin-inline-end: 12px;
  ${theme.breakpoints.up("tablet")} {
    inline-size: 50%;
    margin-block-end: 0;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    inline-size: 100%;
    margin-block-end: 8px;
    margin-inline-end: 0;
  }
`;

export const TopicLink = styled.div`
  ${StyledTopicLink} {
    margin-block-end: 8px;

    color: #000000;
    font-weight: 700;
    font-size: 14px;
    font-family: ${fontRobotoCondensed};
    line-height: 16.41px;
  }
`;

export const Headline = styled.div`
  ${ContentHeadline} {
    color: #000000;
  }

  ${ContentHeadline}, ${SponsorHeadline}, ${Flag} {
    font-size: 16px;
    font-family: ${fontMerriweather};
    line-height: 140%;

    ${theme.breakpoints.up("tablet")} {
      font-size: 18px;
    }
  }
`;

export const ActionBar = styled.div`
  ${ContentActionBar} {
    time {
      color: #999999;
      font-size: 12px;
      line-height: 14px;
    }
  }
`;

export const StyledNumber = styled(MyDailyFiveNumber)`
  margin-inline-end: 18px;
  ${theme.breakpoints.up("tablet")} {
    margin-inline-end: 16px;
  }
`;

export const Cover = styled.div`
  figure {
    inline-size: 80px;
    block-size: 80px;

    border-radius: 8px;

    overflow: hidden;

    ${theme.breakpoints.up("tablet")} {
      aspect-ratio: 120/79;

      inline-size: 100%;
      block-size: 100%;
    }
    ${theme.breakpoints.up("desktop")} {
      aspect-ratio: 191/125;
    }
    ${theme.breakpoints.up("mediumDesktop")} {
      aspect-ratio: 211/139;
    }
  }
`;
